import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class SettingsResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("SettingsResourcesPackage");
    }
    public get assets_popups_settings_settings_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/popups/settings/settings_1x.atlas.json");
    }
    public get assets_popups_settings_frame_big_png(): Texture {
        return this.assets_popups_settings_settings_1x_atlas_json.textures["frame_big.png"];
    }
    public get assets_popups_settings_frame_small_png(): Texture {
        return this.assets_popups_settings_settings_1x_atlas_json.textures["frame_small.png"];
    }
    public get assets_popups_settings_reset_button_png(): Texture {
        return this.assets_popups_settings_settings_1x_atlas_json.textures["reset_button.png"];
    }
    public get assets_popups_settings_settings_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/popups/settings/settings_1x.atlas.png");
    }
}

